var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsPaymentError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 197 149",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A4B25698-C61F-4483-B865-0BE98517D2DA@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-734 -224)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(734 224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m108 122.75c-21.639 4.9478-43.914-5.121-54.698-24.725-10.784-19.604-7.4946-44.049 8.0768-60.027",
    stroke: "#00B9F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m95 23h2.3282c19.355-0.012918 37.025 10.905 45.526 28.131 8.5011 17.226 6.3465 37.745-5.5514 52.869",
    stroke: "#00B9F2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(36 43)",
    opacity: 0.2,
    stroke: "#58595B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m100.56 76.214c-22.314 19.035-55.092 19.281-77.69 0.58405-22.598-18.697-28.472-50.924-13.922-76.383",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "79.687 72.219 102.08 75.036 99.378 96.607"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(59 4)",
    opacity: 0.2,
    stroke: "#58595B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m2.0465 20.294c22.106-16.58 52.663-16.187 74.333 0.95526 21.67 17.143 28.98 46.706 17.783 71.917",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "23.047 25.739 0.62791 21.985 4.2558 0.48293"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 66)",
    opacity: 0.2,
    stroke: "#D3CFD0"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Path",
    x1: 18.88,
    x2: 0.073333,
    y1: 10.08,
    y2: 10.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path",
    x1: 9.4767,
    x2: 9.4767,
    y1: 0.67667,
    y2: 19.483
  })), /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(138)",
    opacity: 0.2,
    stroke: "#A39D9F"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Path",
    x1: 15.086,
    y1: 7.6625,
    y2: 7.6625
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path",
    x1: 7.5429,
    x2: 7.5429,
    y1: 0.215,
    y2: 15.088
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175 127)",
    opacity: 0.2,
    stroke: "#D3CFD0"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Path",
    x1: 11.086,
    x2: 11.086,
    y1: 0.587,
    y2: 21.701
  }), /*#__PURE__*/React.createElement("line", {
    id: "a",
    x1: 0.552,
    x2: 21.643,
    y1: 11.144,
    y2: 11.144
  })), /*#__PURE__*/React.createElement("path", {
    d: "m109 82c-7.6608-5.3333-18.339-5.3333-26 0",
    stroke: "#0091D0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 119,
    cy: 66,
    r: 3,
    fill: "#0091D0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 66,
    r: 3,
    fill: "#0091D0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPaymentError);
export default __webpack_public_path__ + "static/media/icons_payment_error.6d9791b1ff6a0f5f04f9ba4c365b4847.svg";
export { ForwardRef as ReactComponent };